import { FunctionComponent as F, useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useAppDispatch } from "./core/store/hooks";
import { retrieveUserAsync } from './core/store/user/user.thunks';
import { ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { theme } from './core/theme/theme';
import { AppRouter } from './core/router/AppRouter';
import Header from './components/Header';
import Footer from './components/Footer';
import './styles/global.css';

const App: F = () =>
{
  const appDispatch = useAppDispatch();

  useEffect(() =>
  {
    appDispatch(retrieveUserAsync())
      .then(() => setUserRetrieved(true));
  }, []);
  const [userRetrieved, setUserRetrieved] = useState(false);

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '98vh' }}>

          <Header/>

          {userRetrieved ? <AppRouter/> : <></>}

          <Footer/>

        </Box>
      </ThemeProvider>
    </BrowserRouter>);
};

export default App;
